define('product_line_stock_description.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('product_line_stock_description', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"showStockDescription") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":230}}})) != null ? stack1 : "")
    + "  ";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <p class=\"product-line-stock-description-msg-description "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"stockInfo") : depth0)) != null ? _nl_(stack1,"stockDescriptionClass") : stack1), depth0))
    + "\"><i class=\"product-line-stock-description-icon-description\"></i> "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"stockInfo") : depth0)) != null ? _nl_(stack1,"stockDescription") : stack1), depth0))
    + " </p> ";
},"useData":true}, 'extensions/SC/Manor/3.6.0/', 'extensions/SC/Manor/3.6.0/', Handlebars);
});